// extracted by mini-css-extract-plugin
export default {"productCard":"ProductCard_common_productCard__LuUUI"};